import { useRef } from 'react';
// @ts-ignore
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import { translate } from '@openclassrooms/translations';

import { getFacebookConfig } from '@openclassrooms/common-app/social/services';

import SocialButton from './LoginButton';
import type { SocialLoginButtonProps } from './types';

const FacebookLoginButton = ({
  onSuccess,
  onError = () => {},
  isRegister = false,
  disabled = false,
}: SocialLoginButtonProps) => {
  const { clientId } = getFacebookConfig();
  const popupOpened = useRef(false);

  const delayedCheckPopupOpened = () =>
    setTimeout(() => {
      if (!popupOpened.current) {
        onError(translate('auth.errors.popups_facebook_blocked'));
      }
    }, 500);

  return (
    <FacebookLogin
      appId={clientId}
      fields="name,email,picture,birthday"
      onClick={() => null}
      callback={onSuccess}
      version="12.0"
      isMobile={false}
      render={(renderProps: { isProcessing: boolean; onClick: (e: MouseEvent) => void }) => {
        if (renderProps.isProcessing) {
          popupOpened.current = true;
        }
        return (
          <SocialButton
            shouldDisplayAsIcon
            disabled={disabled}
            isRegister={isRegister}
            socialVariant="facebook"
            onClick={(evt) => {
              renderProps.onClick(evt);
              delayedCheckPopupOpened();
            }}
          />
        );
      }}
    />
  );
};

export default FacebookLoginButton;
